import sharePlainNewSvg from '@/static/imgs/feed-shareNew.svg';

import { Button, Input, message, Popover } from 'antd';
import ClipboardJS from 'clipboard';

const clipboard = new ClipboardJS('#copyBtn');

clipboard.on('success', () => {
  message.success('复制成功');
});

type ShareButtonProps = {
  url: string;
};

const ShareButton: React.FC<ShareButtonProps> = (props) => {
  const url = props.url.startsWith('http')
    ? props.url
    : window.location.origin + props.url;

  return (
    <Popover
      content={
        <div data-flex>
          <Input defaultValue={url} />
          <Button id="copyBtn" data-clipboard-text={url}>
            复制
          </Button>
        </div>
      }
      title="分享的链接"
      trigger="click"
    >
      <div className="flex items-center cursor-pointer">
        <img src={sharePlainNewSvg} />
        <span className="text-13px text-hex-4E5969 ml-5px">分享</span>
      </div>
    </Popover>
  );
};

export default ShareButton;
